export default __webpack_public_path__ + "static/popups-f690d340c85d6bd25a5daedbe2c4d81e.png";